import api from './api';

export interface Client {
  id: string;
  company_name: string;
  domain?: string;
  subscription_tier?: string;
  max_users?: number;
  max_projects?: number;
  created_date: string;
}

export interface CreateClientRequest {
  company_name: string;
  domain?: string;
  subscription_tier?: string;
  max_users?: number;
  max_projects?: number;
}

export const clientService = {
  async getAll(): Promise<Client[]> {
    const response = await api.get<Client[]>('/clients/');
    return response.data;
  },

  async getById(id: string): Promise<Client> {
    const response = await api.get<Client>(`/clients/${id}`);
    return response.data;
  },

  async create(data: CreateClientRequest): Promise<Client> {
    const response = await api.post<Client>('/clients/', data);
    return response.data;
  },
};
